import { render, staticRenderFns } from "./RatingDirectionsStatIndex.vue?vue&type=template&id=2b321dd1"
import script from "./RatingDirectionsStatIndex.vue?vue&type=script&lang=js"
export * from "./RatingDirectionsStatIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports